<div class="main-content">
  <router-outlet />
</div>
